import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useKioskConfiguration } from '../../contexts/kioskConfiguration/KioskConfigurationContext';
import { RootState } from '../../store/store';
import { KIOSK_PARAM, KIOSK_PARAM_ON_FLAG } from '../../App';


const LOCAL_STORAGE_LAST_ACTIVITY_KEY = 'lastActivity';

export const ActivityChecker = (): React.ReactElement => {
  const kioskConfigurationContext = useKioskConfiguration()
  const isKiosk = useSelector((state: RootState) => state.app.isKiosk)

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_LAST_ACTIVITY_KEY, new Date().toISOString());

    document.addEventListener('keydown', () => {
      localStorage.setItem(LOCAL_STORAGE_LAST_ACTIVITY_KEY, new Date().toISOString());
    });
    document.addEventListener('mousedown', () => {
      localStorage.setItem(LOCAL_STORAGE_LAST_ACTIVITY_KEY, new Date().toISOString());
    });
    document.addEventListener('touchend', () => {
      localStorage.setItem(LOCAL_STORAGE_LAST_ACTIVITY_KEY, new Date().toISOString());
    });

    const interval = setInterval(() => {
      const lastActivity = localStorage.getItem(LOCAL_STORAGE_LAST_ACTIVITY_KEY);
      if (location.pathname === '/') {
        return
      }

      if (lastActivity && (new Date().getTime() - new Date(lastActivity).getTime()) > (kioskConfigurationContext.kioskConfiguration.activityTimeout * 1000)) {
        let url = '/';
        if (isKiosk) {
          url += `?${KIOSK_PARAM}=${KIOSK_PARAM_ON_FLAG}`
        }
        window.location.href = url;
      }
    }, 1000);
  }, []);

  return <></>
}
